import React from 'react';
import { Modal, Form, Input, Row, Col, Switch } from 'antd';
import useApi from '../../hooks/useApi';

const { TextArea } = Input;

const ModalEdit = ({ visible, id, onCancel, onConfirm, initialData }) => {
  const [form] = Form.useForm();

  const { callApi: editGrupo } = useApi(`https://vision.alfama.com/api/update/grupos_permissao/${id}`, {
    method: 'PUT',
    includeToken: true,
    successMessage: 'Grupo atualizado com sucesso!',
    errorMessage: 'Erro ao atualizar grupo'
  });

  React.useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        nome: initialData.nome,
        codigo: initialData.codigo_grupo,
        descricao: initialData.descricao,
        situacao: initialData.status === 'ativo',
      });
    }
  }, [initialData, form]);

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      const formattedValues = {
        ...values,
        situacao: values.situacao ? 1 : 0
      };
      await editGrupo(formattedValues);
      form.resetFields();
      onConfirm(true);
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      console.error('Erro ao editar grupo:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={`Editar Grupo - ID: ${id}`}
      open={visible}
      onCancel={handleCancel}
      onOk={handleConfirm}
      okText="Salvar"
      cancelText="Cancelar"
      maskClosable={false}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={9}>
            <Form.Item
              name="nome"
              label="Nome"
              rules={[{ required: true, message: 'Por favor, insira o nome do grupo' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item
              name="codigo"
              label="Código RLS"
              rules={[
                { required: true, message: 'Por favor, insira o código do grupo' }
              ]}
              tooltip="O codigo será utilizado em dashboards que precisam de regras RLS"
            >
              <Input 
                placeholder="EX1234-DEPARTAMENTO"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="situacao"
              label="Situação"
              valuePropName="checked"
            >
              <Switch 
                checkedChildren="Ativo" 
                unCheckedChildren="Bloqueado"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="descricao"
              label="Descrição"
              rules={[{ required: true, message: 'Por favor, insira a descrição do grupo' }]}
            >
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalEdit;